import { PDFListing, Detail as UserDetail } from "../pages/PDFListing";

import { Account, Profile as AdminProfile } from "../pages/Account";
import { APP_ROUTES } from "../helpers/routeHelpers";
import { Roles } from "../constants";

import { WebForm } from "../pages/WebForm";

let { Admin } = Roles;

const authProtectedRoutes = [
    {
        path: APP_ROUTES.PDF_LISTING,
        component: PDFListing,
        permissions: [Admin],
        exact: true
    },

    {
        path: APP_ROUTES.WEB_FORM,
        component: WebForm,
        permissions: [Admin],
        exact: true
    },

    {
        path: APP_ROUTES.ACCOUNT,
        component: Account,
        permissions: [Admin],
        exact: false
    }
];

export { authProtectedRoutes };
